import {
  initialCharterStockClassesTableInfo,
  initialCharterStockClassesState,
  type CharterStockClassesAction,
  type CharterStockClassesState,
} from './charterStockClassesTypes';

export function charterStockClassesReducer(
  state: CharterStockClassesState,
  action: CharterStockClassesAction,
): CharterStockClassesState {
  switch (action.type) {
    case 'SET_TABLE_INFO':
      return { ...state, tableInfo: action.tableInfo };
    case 'PATCH_TABLE_INFO':
      return { ...state, tableInfo: { ...state.tableInfo, ...action.patch } };
    case 'SHOW_ACTIVE_FILING':
    case 'CLEAR_FILING_FILTER':
      return {
        ...state,
        tableInfo: {
          ...state.tableInfo,
          charterFilingId: undefined,
          skipCount: 0,
        },
      };
  }
}

export { initialCharterStockClassesTableInfo, initialCharterStockClassesState };
